const userSections = {
    veterinarian: { key: 'veterinarian', name: '{{lang}}Veterinarian', img: '/images/kheiry/Veterinarian.png' },
    horseBreeder: { key: 'horseBreeder', name: '{{lang}}Horse Breeder', img: '/images/kheiry/horsebreeder.png' },
}

// Page configs for UserApplet: operations (veterinarian) and orders (horseBreeder)
// Uses fetchUrl: 'getUserRecords' and self to filter by current user - NOT adminPages
const userAppletPageBases = {
    forms: {
        key: 'forms',
        page: 'forms',
        title: '{{lang}}Forms',
        description: '{{lang}}Forms List',
        pageType: 'form',
        parent: 'forms',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        sort: { 'uDate': -1 },
        image: '/images/kheiry/form1.png',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'view' },
            seeStatus: { key: "seeStatus", label: '{{lang}}See Orders Status', color: '#fff', function: "openStatusModal", permission: '' },
        },
        populates: [
            { key: 'values.modelMale', model: 'records', select: ['values.name', 'values.faName'] },
            { key: 'values.veterinarian', model: 'employees', select: ['name'] },
            { key: 'values.customer', model: 'employees', select: ['name'] },
        ],
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.address', type: 'TextInput', information: { label: '{{lang}}Address', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'TextInput', information: { section: 'female', label: '{{lang}}model', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMale', type: 'SelectInput', information: { disabled: true, dontShowExtraValue: true, section: 'male', label: '{{lang}}model Male', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', description: 'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleDesc', type: 'TextInput', information: { disabled: true, section: 'male', label: '{{lang}}Model Male Description', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.microChipNumberMale', type: 'TextInput', information: { disabled: true, section: 'male', label: '{{lang}}Micro Chip Number Male', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
    },
    contracts: {
        key: 'contracts',
        page: 'forms',
        title: '{{lang}}Contracts',
        description: '{{lang}}Contracts List',
        pageType: 'form',
        parent: 'forms',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        sort: { 'uDate': -1 },
        addNew: -1,
        noAddNew: true,
        image: '/images/kheiry/form1.png',
        actions: {
            seeStatus: { key: "seeStatus", label: '{{lang}}See Orders Status', color: '#fff', function: "openStatusModal", permission: '' },
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'view' },
        },
        postBody: { 'values.lastFollowUpResult': 'قرارداد' },
        populates: [
            { key: 'values.veterinarian', model: 'employees', select: ['name'] },
            { key: 'values.customer', model: 'employees', select: ['name'] },
        ],
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.veterinarian', type: 'SelectInput', information: { label: '{{lang}}Veterinarian', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: { filter: { userType: 'veterinarian' } }, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customer', type: 'SelectInput', information: { label: '{{lang}}Customer', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: { userType: 'customer' }, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.phoneNumber', type: 'PhoneInput', information: { label: '{{lang}}Phone', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}formDate', disabled: false, required: false }, showMain: true, inExport: true },
        ],
    },
}

/**
 * Get page configs for UserApplet by route.
 * route: 'operations' = veterinarian (self: 'veterinarian'), 'orders' = horseBreeder (self: 'customer')
 * Uses fetchUrl: 'getUserRecords' and self for filtering - like userWidgets pattern.
 */
export function getPagesForUserRoute(route) {
    const isOperations = route === 'operations'
    const self = isOperations ? 'veterinarian' : 'customer'
    const processOwner = self
    const pages = {}
    for (const [key, base] of Object.entries(userAppletPageBases)) {
        pages[key] = {
            ...base,
            fetchUrl: 'getUserRecords',
            self,
            postBody: {
                frame: 'forms',
                
                ...(base.postBody || {}),
            },
        }
    }
    return pages
}

const userPages = {
    veterinarian: {
        key: 'veterinarian',
        title: '{{lang}}Veterinarian',
        description: '{{lang}}Veterinarian Registration',
        headers: [
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'family', type: 'TextInput', information: { label: '{{lang}}Family', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'nationalId', type: 'TextInput', information: { label: '{{lang}}National ID', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'phone', type: 'PhoneInput', information: { label: '{{lang}}Phone Number', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'email', type: 'EmailInput', information: { label: '{{lang}}Email', disabled: false, required: false }, showMain: true },
            { col: '6', key: 'password', type: 'PasswordInput', information: { label: '{{lang}}Password', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'confirmPassword', type: 'PasswordInput', information: { label: '{{lang}}Confirm Password', disabled: false, required: true }, showMain: true },
            { col: '12', key: 'licenseNumber', type: 'TextInput', information: { label: '{{lang}}License Number', disabled: false, required: true }, showMain: true },
            { col: '12', key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: true },
        ]
    },
    horseBreeder: {
        key: 'horseBreeder',
        title: '{{lang}}Horse Breeder',
        description: '{{lang}}Horse Breeder Registration',
        headers: [
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'family', type: 'TextInput', information: { label: '{{lang}}Family', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'nationalId', type: 'TextInput', information: { label: '{{lang}}National ID', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'phone', type: 'PhoneInput', information: { label: '{{lang}}Phone Number', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'email', type: 'EmailInput', information: { label: '{{lang}}Email', disabled: false, required: false }, showMain: true },
            { col: '6', key: 'password', type: 'PasswordInput', information: { label: '{{lang}}Password', disabled: false, required: true }, showMain: true },
            { col: '6', key: 'confirmPassword', type: 'PasswordInput', information: { label: '{{lang}}Confirm Password', disabled: false, required: true }, showMain: true },
            { col: '12', key: 'stableName', type: 'TextInput', information: { label: '{{lang}}Stable Name', disabled: false, required: false }, showMain: true },
            { col: '12', key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: true },
        ]
    },
}

export { userPages, userSections }











